import { useState } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import MediaKit from './components/MediaKit';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MediaKit />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;